import styles from './progress-bar.module.scss';

const ProgressBar = () => (
  <div className={styles.progressBar}>
    <div className={styles.progressBarValue}></div>
  </div>
);

export default ProgressBar;
